import { paymentsClient } from './clients';
// @ts-expect-error Untyped module
import { catchAndRethrowNetworkError } from 'crm_data/bCommerce/monitoring/errorUtils';
export const fetchCountryMetadata = ({
  countryCode
}) => {
  return paymentsClient.get(`payments-checkout/v1/checkout-sessions/address-metadata/${countryCode}`).catch(catchAndRethrowNetworkError);
};